import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getLoggedInUser, getOneAdmin, getTeams, getJobTitles, updateAdmin } from "../../utils/helper";
import Loader from "../../utils/Loader";
import avatar from "../../assets/img/profile_av.jpg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { alertSuccess, alertError } from "../../utils/alerts";
import { months } from "../../utils/dataFile";

const INIT_DETAILS = {
    id:"",
    first_name: "",
    last_name: "",
    middle_name: "",
    email: "",
    phone: "",
    status: "",
    
    profile_pic:"",
    branch: "",
    organization: "",
    department: "",
    staff_id: "",
    hire_year: "",
    hire_month: "",
    hire_date: "",
    job_title: "",

    personal_email: "",
    personal_phone: "",
    residential_address: "",
    marital_status: "single",
    date_of_birth: "",

    pfa_name: "",
    pfa_account: "",
    pfa_pin: "",
    etcc_pin: "",
    bank_name: "",
    bank_address: "",
    account_type: "",
    account_number: "",

    nok_name: "",
    nok_phone: "",
    nok_address: "",
    nok_relationship: "",

    reference_name: "",
    reference_address: "",

    qualifications: [{
        qualification_institution: "",
        qualification_qualification: "",
        qualification_field: "",
        qualification_grade: "",
        qualification_start: null,
        qualification_end: null,
    }],
};

export default function ViewEmployee(props) {
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const [profile, setEmployee] = useState(null);
    const [teams, setTeams] = useState(null);
    const [roles, setRoles] = useState(null);
    const [details, setDetails] = useState(INIT_DETAILS);

    const TOKEN = localStorage.getItem("kloka:token:data");
    const [admin, setAdmin] = useState(null);

    useEffect(() => {
        if(TOKEN){
            getLoggedInUser(TOKEN).then((res) => { 
                if(res.data.success){
                    setAdmin(res.data.data);  
                }
            }).catch((err) => { console.log(err.response) });
        }
    }, [TOKEN]);

    const isAdmin = admin
        ? admin &&
        admin.categories &&  admin.categories.includes("HR")
         : false;
    
    useEffect(() => {
        setTimeout(() => {
            if (admin && !isAdmin) {
                props.history.push("/dashboard");
                alertError("Unauthorised access");
            } 
        }, 4500);
    }, [props.history, admin, isAdmin]);

    useEffect(() => {
        if(id){
            setLoading(true)
            getOneAdmin(id)
                .then((res) => { 
                    setEmployee(res.data.data); setLoading(false) 
                })
                .catch((err) => { 
                    console.log(err.response); setLoading(false); 
                });
        }
    }, [id]);

    useEffect(() => {
        getTeams()
            .then((res) => { 
                setTeams(res.data.data); 
            })
            .catch((err) => { 
                console.log(err.response);
            });
    }, []);

    useEffect(() => {
        getJobTitles()
            .then((res) => { 
                setRoles(res.data.data); 
            })
            .catch((err) => { 
                console.log(err.response);
            });
    }, []);

    const handleChange = (e) => {
        e.persist();
        setDetails((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        setDetails((prev) => ({
            ...prev,
            first_name: (profile && profile.first_name) || "",
            last_name: (profile && profile.last_name) || "",
            middle_name: (profile && profile.middle_name) || "",
            status: (profile && profile.status) || "",
            email: (profile && profile.email) || "",
            phone: (profile && profile.phone) || "",
            gender: (profile && profile.gender) || "male",
            marital_status: (profile && profile.marital_status) || "single",
            date_of_birth: (profile && profile.date_of_birth) || "",
            town_of_birth: (profile && profile.town_of_birth) || "",
            state_of_origin: (profile && profile.state_of_origin) || "",
            nationality: (profile && profile.nationality) || "nigerian",
            profile_pic: (profile && profile.profile_pic) || "",

            personal_email: (profile && profile.personal_email) || "",
            personal_phone: (profile && profile.personal_phone) || "",
            residential_address: (profile && profile.residential_address) || "",
            
            organization: (profile && profile.organization) || "",
            branch: (profile && profile.branch) || "",
            team: (profile && profile.team) || "",
            staff_id: (profile && profile.staff_id) || "",
            job_title: (profile && profile.job_title) || "",
            hire_year: (profile && profile.hire_year) || "",
            hire_month: (profile && profile.hire_month) || "",
            hire_date: (profile && profile.hire_date) || "",

            pfa_name: (profile && profile.pfa_name) || "",
            pfa_account: (profile && profile.pfa_account) || "",
            pfa_pin: (profile && profile.pfa_pin) || "",
            etcc_pin: (profile && profile.etcc_pin) || "",

            bank_name: (profile && profile.bank_name) || "",
            bank_address: (profile && profile.bank_address) || "",
            account_type: (profile && profile.account_type) || "",
            account_number: (profile && profile.account_number) || "",

            qualifications: (profile && profile.qualifications) || [],

            nok_name: (profile && profile.nok_name) || "",
            nok_phone: (profile && profile.nok_phone) || "",
            nok_address: (profile && profile.nok_address) || "",
            nok_relationship: (profile && profile.nok_relationship) || "",

            reference_name: (profile && profile.reference_name) || "",
            reference_address: (profile && profile.reference_address) || "",

            employer_name: (profile && profile.employer_name) || "",
            employer_address: (profile && profile.employer_address) || "",
            employer_country: (profile && profile.employer_country) || "",
            employer_start: (profile && profile.employer_start) || "",
            employer_end: (profile && profile.employer_end) || "",

            // qualification_start: moment(qualStartDate).format('YYYY'),
            // qualification_end: moment(qualEndDate).format('YYYY'),
        }));
    }, [profile]);

    const handleUpdatePersonal = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const { first_name, last_name, middle_name, hire_year, hire_month, hire_date, team, job_title, staff_id } = details;
            const data = { first_name, last_name, middle_name, hire_year, hire_month, hire_date, team, job_title, staff_id };
            if(data.first_name && data.last_name && data.hire_year && data.hire_month && data.hire_date && data.team && data.job_title){
                setLoading(true);
                updateAdmin(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                });
            };
        } else {alert("Personal information update was canceled!");}
    }

    const handleDisable = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            let status = profile.active === false ? true : false;
            const data = {id, active: status}
            setLoading(true);
                updateAdmin(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                });
        }
    }

    return (
        <>
            {isAdmin && 
                <div className="spur-card-menu">
                    <button type="button" data-toggle="modal" data-target="#personalModal" className="pull-right btn topbtn btn-primary">
                        <i className="fa fa-solid fa-pencil"></i> UPDATE
                    </button>
                
                    <button type="button" onClick={handleDisable} className="pull-right btn topbtn btn-primary mr-2" 
                    
                    style={{backgroundColor: `${profile.active ? 'red' : '#093'}`}}>
                        {profile.active ? "DISABLE" : "ACTIVATE"} ACCOUNT
                    </button>
                </div>
            }

            <h1 className="dash-title"><Link to="/employees" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            {loading ? <Loader /> : 
                <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="profile-view">
                                <div className="profile-img-wrap">
                                    <div className="profile-img">
                                        <img 
                                            src={(details && (details.profile_pic !== "")) ? details.profile_pic : avatar} 
                                            alt="avatar" 
                                        />
                                    </div>
                                </div>
                            
                                <div className="profile-basic">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="profile-info-left">
                                                <h3 className="user-name m-t-0 mb-0">{details.first_name} {details.last_name} </h3>
                                                <h6 className="text-muted">{details.job_title && details.job_title?.name}</h6>
                                                <small className="text-muted"></small>
                                                <div className="staff-id">Team: {details.team && details.team?.team_name}</div>
                                                <div className="staff-id">Employee ID: {details.staff_no ? details.staff_id : "KR-FT-1009"} </div>
                                                <div className="staff-id small doj text-muted">Hire Year: {details.hire_year ? details.hire_year 
                                                : "2024"} </div>
                                                <div className="staff-id small doj text-muted">Hire Month: {details.hire_month ? details.hire_month 
                                                : "January"} </div>
                                                <div className="staff-id small doj text-muted">Hire Date: {details.hire_date ? details.hire_date 
                                                : "1st"} </div>
                                                {/* <div className="staff-msg">
                                                    <button className="btn btn-custom" disabled>Start Chating</button>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="col-md-7">
                                            <ul className="personal-info">
                                                <li>
                                                    <div className="title">Organization:</div>
                                                    <div className="text">{details.organization && details.organization?.name}</div>
                                                </li>
                                                <li>
                                                    <div className="title">Work Phone:</div>
                                                    <div className="text"><span>{details.phone} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Work Email:</div>
                                                    <div className="text"><span>{details.email} </span></div>
                                                </li>
                                                <li>
                                                    <div className="title">Team:</div>
                                                    <div className="text">{details.team && details.team?.team_name}</div>
                                                </li>
                                                <li>
                                                    <div className="title">Branch:</div>
                                                    <div className="text">{details.branch && details.branch?.branch_name} </div>
                                                </li>
                                                {/* <li>
                                                    <div className="title">Staff ID:</div>
                                                    <div className="text">{details.staff_id && details.staff_id} </div>
                                                </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Personal Details 
                            </h3>
                            <ul className="personal-info">
                                <li>
                                    <div className="title">Personal Email:</div>
                                    <div className="text">{details.personal_email && details.personal_email}</div>
                                </li>
                                <li>
                                    <div className="title">Personal Phone:</div>
                                    <div className="text">{details.personal_phone && details.personal_phone}</div>
                                </li>
                                <li>
                                    <div className="title">Birthday:</div>
                                    <div className="text"><span>{details.date_of_birth} </span></div>
                                </li>
                                <li>
                                    <div className="title">Residential Address:</div>
                                    <div className="text">{details.residential_address && details.residential_address}</div>
                                </li>
                                <li>
                                    <div className="title">State of Origin:</div>
                                    <div className="text">{details.state_of_origin && details.state_of_origin} </div>
                                </li>
                                <li>
                                    <div className="title">Nationality:</div>
                                    <div className="text">{details.nationality && details.nationality}</div>
                                </li>
                                <li>
                                    <div className="title">Marital Status:</div>
                                    <div className="text">{details.marital_status && details.marital_status}</div>
                                </li>
                                <li>
                                    <div className="title">Gender:</div>
                                    <div className="text">{details.gender && details.gender}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Bank Information 
                            </h3>
                            
                            <ul className="personal-info">
                                <li>
                                    <div className="title">Bank name</div>
                                    <div className="text">{details.bank_name && details.bank_name}</div>
                                </li>
                                <li>
                                    <div className="title">Bank account No.</div>
                                    <div className="text">{details.account_number && details.account_number}</div>
                                </li>
                                <li>
                                    <div className="title">Bank Account Type:</div>
                                    <div className="text">{details.account_type && details.account_type}</div>
                                </li>
                                <li>
                                    <div className="title">Bank Branch:</div>
                                    <div className="text">{details.bank_address && details.bank_address}</div>
                                </li>
                                <li>
                                    <div className="title">ETCC PIN:</div>
                                    <div className="text">{details.etcc_pin && details.etcc_pin}</div>
                                </li>
                                <li>
                                    <div className="title">Pension Fund Administrator:</div>
                                    <div className="text">{details.pfa_name && details.pfa_name}</div>
                                </li>
                                <li>
                                    <div className="title">PFA Account Number:</div>
                                    <div className="text">{details.pfa_account && details.pfa_account}</div>
                                </li>
                                <li>
                                    <div className="title">PFA PIN:</div>
                                    <div className="text">{details.pfa_pin && details.pfa_pin}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Next of Kin Information 
                            </h3>
                            {(details.nok_name && details.nok_address && details.nok_phone) ? 
                            <div className="table-responsive">
                                <table className="table table-nowrap table-bordered table-stripped">
                                    <thead><tr><th>Name</th><th>Relationship</th><th>Address</th><th>Phone</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>{details.nok_name && details.nok_name}</td>
                                            <td>{details.nok_relationship && details.nok_relationship}</td>
                                            <td>{details.nok_address && details.nok_address}</td>
                                            <td>{details.nok_phone && details.nok_phone}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>: <div className="alert alert-danger myerror d-block">No record found</div> }
                        </div>
                    </div>
                </div>

                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Guarantor Information 
                            </h3>
                            {(details.reference_name && details.reference_address) ? 
                            <div className="table-responsive">
                                <table className="table table-nowrap table-bordered table-stripped">
                                    <thead><tr><th>Reference Name</th><th>Reference Address</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>{details.reference_name && details.reference_name}</td>
                                            <td>{details.reference_address && details.reference_address}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> : <div className="alert alert-danger myerror d-block">No record found</div>  }
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Education Information 
                            </h3>
                            {/* <div className="experience-box">
                                <ul className="experience-list">
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">International College of Arts and Science (UG)</a>
                                                <div>Bsc Computer Science</div>
                                                <span className="time">2000 - 2003</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">International College of Arts and Science (PG)</a>
                                                <div>Msc Computer Science</div>
                                                <span className="time">2000 - 2003</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className="col-md-6 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body"> 
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Experience 
                            </h3>
                            {/* <div className="experience-box">
                                <ul className="experience-list">
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">Web Designer at Zen Corporation</a>
                                                <span className="time">Jan 2013 - Present (5 years 2 months)</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">Web Designer at Ron-tech</a>
                                                <span className="time">Jan 2013 - Present (5 years 2 months)</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="experience-user">
                                            <div className="before-circle"></div>
                                        </div>
                                        <div className="experience-content">
                                            <div className="timeline-content">
                                                <a href="#/" className="name">Web Designer at Dalt Technology</a>
                                                <span className="time">Jan 2013 - Present (5 years 2 months)</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>

            
            <div id="personalModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">UPDATE EMPLOYEE BASIC INFORMATION</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">First Name: <span>*</span></label>
                                    <input type="text" name="first_name" className="form-control" required placeholder="First Name" 
                                    onChange={handleChange} defaultValue={details.first_name && details.first_name }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Last Name: <span>*</span></label>
                                    <input type="text" name="last_name" className="form-control" required placeholder="Last Name" 
                                    onChange={handleChange} defaultValue={details.last_name && details.last_name }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Middle Name: </label>
                                    <input type="text" name="middle_name" className="form-control" placeholder="Middle Name" 
                                    onChange={handleChange} defaultValue={details.middle_name && details.middle_name }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Staff ID/No: </label>
                                    <input type="text" name="staff_id" className="form-control" placeholder="Staff ID/No" 
                                    onChange={handleChange} defaultValue={details.staff_id && details.staff_id }  disabled={loading} />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Year of Joining: <span>*</span></label>
                                    <select className="form-control form-select" name="hire_year" id="hire_year" required 
                                    onChange={handleChange} defaultValue={details.hire_year && details.hire_year} disabled={loading}>
                                        <option value="2020">2020</option>
                                        <option value="2021">2021</option>
                                        <option value="2022">2022</option>
                                        <option value="2023">2023</option>
                                        <option value="2024">2024</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Anniversary Month: <span>*</span></label>
                                    <select className="form-control form-select" name="hire_month" id="hire_month" required 
                                    onChange={handleChange} defaultValue={details.hire_month && details.hire_month} disabled={loading}>
                                        {months && months.map((item, i) => (
                                            <option key={i} value={item.month}>{item.month}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Anniversary Date: <span>*</span></label>
                                    <select className="form-control form-select" name="hire_date" id="hire_date" required 
                                    onChange={handleChange} defaultValue={details.hire_date && details.hire_date} disabled={loading}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>
                                        <option value="21">21</option>
                                        <option value="22">22</option>
                                        <option value="23">23</option>
                                        <option value="24">24</option>
                                        <option value="25">25</option>
                                        <option value="26">26</option>
                                        <option value="27">27</option>
                                        <option value="28">28</option>
                                        <option value="29">29</option>
                                        <option value="30">30</option>
                                        <option value="31">31</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Team: <span>*</span></label>
                                    <select className="form-control form-select" name="team" id="team" required 
                                    onChange={handleChange} defaultValue={details.team && details.team?._id} disabled={loading}>
                                        <option value=''>Select Team...</option>
                                        {teams && teams.map((item, i) => (
                                            <option key={i} value={item._id}>{item.team_name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Job Title: <span>*</span></label>
                                    <select className="form-control form-select" name="job_title" id="job_title" required 
                                    onChange={handleChange} defaultValue={details.job_title && details.job_title?._id} disabled={loading}>
                                        <option value=''>Select Job Title...</option>
                                        {roles && roles.map((item, i) => (
                                            <option key={i} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            {isAdmin && 
                                <div className="row">
                                    <div className="col-md-12 form-group">
                                        <button 
                                            type="submit" 
                                            className="btn" 
                                            disabled={loading}
                                            onClick={handleUpdatePersonal} 
                                        >
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div> 

                
            </> }
        </>
    );
}
